import { useState } from 'react';
import { Drawer as AntdDrawer } from 'antd';
import { GrFormClose } from 'react-icons/gr';

import styles from './drawer.module.scss';

const Drawer = ({
	footer,
	extra,
	placement,
	size,
	title,
	open,
	width,
	height,
	onClose,
	children,
	style,
	drawerStyles,
	bodyStyle,
	resizable,
}) => {
	// A fixed size/width overrides antd's internal drag size, so track it here
	const [resizedSize, setResizedSize] = useState();

	return (
		<div className={styles['wrapper']}>
			<AntdDrawer
				className={styles['drawer']}
				closeIcon={<GrFormClose className={styles['close-icon']} />}
				footer={footer}
				extra={extra}
				keyboard={true}
				placement={placement}
				size={resizedSize ?? size}
				title={title}
				open={open}
				width={width}
				height={height}
				onClose={onClose}
				style={style}
				styles={drawerStyles}
				bodyStyle={bodyStyle}
				headerStyle={{ display: 'flex', alignItems: 'center' }}
				resizable={resizable ? { onResize: setResizedSize } : false}
			>
				{children}
			</AntdDrawer>
		</div>
	);
};

export default Drawer;
